import config from "../config/config";
import { slugify } from "./slugify";

const generateBreadcrumbs = (pathSegments, product = null, category = null) => {
    const breadcrumbs = [
        {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": config.metadata.siteUrl
        }
    ];

    if (pathSegments.includes("shop-knives")) {
        breadcrumbs.push({
            "@type": "ListItem",
            "position": 2,
            "name": "Shop",
            "item": `${config.metadata.siteUrl}/shop-knives`
        });
    }

    if (category) {
        breadcrumbs.push({
            "@type": "ListItem",
            "position": breadcrumbs.length + 1,
            "name": category.name,
            "item": `${config.metadata.siteUrl}/shop-knives/category/${slugify(category.name)}`
        });
    }

    if (product) {
        breadcrumbs.push({
            "@type": "ListItem",
            "position": breadcrumbs.length + 1,
            "name": product.name,
            "item": `${config.metadata.siteUrl}/shop-knives/knife/${product.id}/${slugify(product.name)}`
        });
    }

    return {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": breadcrumbs
    };
};

export default generateBreadcrumbs;